export const powerCostCalculation = {
  data() {
    return {
      summerRates: {
        residential: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.45 },
          { limit: 500, rate: 3.70 },
          { limit: 700, rate: 5.04 },
          { limit: 1000, rate: 6.24 },
          { limit: Infinity, rate: 8.46 }
        ],
        nonResidential: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.45 },
          { limit: 500, rate: 3.70 },
          { limit: 700, rate: 5.04 },
          { limit: 1000, rate: 6.24 },
          { limit: Infinity, rate: 8.46 }
        ],
        commercial: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.61 },
          { limit: 500, rate: 3.66 },
          { limit: 700, rate: 4.46 },
          { limit: 1000, rate: 7.08 },
          { limit: Infinity, rate: 7.43 }
        ]
      },
      nonSummerRates: {
        residential: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.16 },
          { limit: 500, rate: 3.03 },
          { limit: 700, rate: 4.14 },
          { limit: 1000, rate: 5.07 },
          { limit: Infinity, rate: 6.63 }
        ],
        nonResidential: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.16 },
          { limit: 500, rate: 3.03 },
          { limit: 700, rate: 4.14 },
          { limit: 1000, rate: 5.07 },
          { limit: Infinity, rate: 6.63 }
        ],
        commercial: [
          { limit: 120, rate: 1.68 },
          { limit: 330, rate: 2.18 },
          { limit: 500, rate: 3.00 },
          { limit: 700, rate: 3.61 },
          { limit: 1000, rate: 5.56 },
          { limit: Infinity, rate: 5.83 }
        ]
      },
    }
  },
  computed: {
    request_date() {
      return this.$store.getters.requestDate;
    },
  },
  methods: {
    calculateElectricityBill(kWh, usageType) {
      console.log('-- calc power --', usageType)
      const date = new Date(this.request_date);
      const summerRates = this.summerRates;
      const nonSummerRates = this.nonSummerRates;

      const summerStart = new Date(date.getFullYear(), 5, 1); // June 1st
      const summerEnd = new Date(date.getFullYear(), 8, 30); // September 30th
      const isSummer = date >= summerStart && date <= summerEnd;

      const rates = isSummer ? summerRates[usageType] : nonSummerRates[usageType];

      let bill = 0;
      let remainingKWh = kWh;

      for (const { limit, rate } of rates) {
        if (remainingKWh > 0) {
          const usage = Math.min(remainingKWh, limit);
          bill += parseFloat((usage * rate).toFixed());
          remainingKWh -= usage;
        } else {
          break;
        }
      }

      return bill;
    }
  },
  computed: {

  },
};
